import React from 'react'
import { formatMoney } from '../../features/utils/formatMoney';
import { getAgeType } from '../../utils/booking/getAgeType';

export default function ChangePriceBreakdown({data}) {
    console.log(data)
    const priceBreakdown = data?.priceBreakdown?.map(obj => ({...obj,
        passengerInfo: data?.passengerInfo?.find(passenger => passenger?.id === obj?.passengerId)
    }));
  return (
    <div className='p-4 bg-primary/5 flex flex-col gap-4'>
      {priceBreakdown?.map((obj,i) => (
        <div key={i}>
            <div className='flex gap-4 items-center justify-between'>
                <b className='capitalize'>
                    Passenger {i+1} ({getAgeType(obj?.passengerInfo?.travelerType)})
                </b>
                <b>{formatMoney(obj?.changeFee + obj?.changePrice + obj?.penaltyFee + obj?.ticketDifference)}</b>
            </div>
            <div className='px-4 py-1 pr-0'>
                <div className='flex justify-between items-center gap-4'>
                    <p>Change fee (airline)</p>
                    <p>{formatMoney(obj?.airlineChangePrice ?? obj?.changePrice)}</p>
                </div>
                <div className='flex justify-between items-center gap-4'>
                    <p>Change fee (adjusted)</p>
                    <p>{formatMoney(obj?.changePrice)}</p>
                </div>
                <div className='flex justify-between items-center gap-4'>
                    <p>Fare difference (airline)</p>
                    <p>{formatMoney(obj?.airlineFareDifference ?? obj?.ticketDifference)}</p>
                </div>
                {(obj?.fareDifferenceMarkup != null || obj?.markupValue) && (
                  <div className='flex justify-between items-center gap-4'>
                    <p>Markup on fare</p>
                    <p>{formatMoney(obj?.fareDifferenceMarkup || 0)}</p>
                  </div>
                )}
                <div className='flex justify-between items-center gap-4'>
                    <p>Fare difference (agent pays)</p>
                    <p>{formatMoney(obj?.ticketDifference)}</p>
                </div>
                <div className='flex justify-between items-center gap-4'>
                    <p>Penalty (airline)</p>
                    <p>{formatMoney(obj?.airlinePenaltyFee ?? obj?.penaltyFee)}</p>
                </div>
                <div className='flex justify-between items-center gap-4'>
                    <p>Penalty (adjusted)</p>
                    <p>{formatMoney(obj?.penaltyFee)}</p>
                </div>
            </div>
        </div>
      ))}
      <hr />
      <div className='flex gap-4 items-center justify-between'>
        <b>Total</b>
        <b>{formatMoney(data?.payable)}</b>
      </div>
    </div>
  )
}
